import { Fragment } from "react";
import { jsx } from "@storybook/theming";
import { IconButton, Icons } from "@storybook/components";
export var ZoomButtons = function (_a) {
    var onZoomIn = _a.onZoomIn, onZoomOut = _a.onZoomOut, onReset = _a.onReset;
    return (jsx(Fragment, null,
        jsx(IconButton, { onClick: onZoomIn },
            jsx(Icons, { icon: "zoom" })),
        jsx(IconButton, { onClick: onZoomOut },
            jsx(Icons, { icon: "zoomout" })),
        jsx(IconButton, { onClick: onReset },
            jsx(Icons, { icon: "zoomreset" }))));
};
export default ZoomButtons;
